import { useState } from 'react';

// Định nghĩa kiểu dữ liệu User
interface Role {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  name: string;
  permissions: any[];
}

interface User {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  username: string;
  password: string;
  email: string;
  phone: string;
  status: string | null;
  roles: Role[];
}

// Custom Hook để quản lý User trong localStorage
const useUserStorage = () => {
  const [user, setUser] = useState<User | null>(() => {
    // Lấy dữ liệu từ localStorage khi khởi tạo
    const userFromStorage = localStorage.getItem('user');
    return userFromStorage ? JSON.parse(userFromStorage) : null;
  });

  // Hàm lưu user vào localStorage
  const saveUser = (userData: User) => {
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  // Hàm xóa user khỏi localStorage
  const clearUser = () => {
    localStorage.removeItem('user');
    setUser(null);
  };

  return { user, saveUser, clearUser };
};

export default useUserStorage;
